import { IonRouterOutlet, IonSplitPane } from '@ionic/react';

import Menu from '@/components/common/Menu/Menu';
import LoggedRoutes from '@/router/loggedRoutes';

export default function DesktopLayout() {
  return (
    <IonSplitPane contentId="main" className="desktop">
      <Menu />
      <IonRouterOutlet id="main">
        <LoggedRoutes />
      </IonRouterOutlet>
    </IonSplitPane>
  );
}
